import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react'

/**
 * The prototype's toast() helper as a hook. Same element, same classes (.toast/.show),
 * same 2.5s dwell — only the imperative DOM poking is gone.
 */
const ToastContext = createContext<(message: string) => void>(() => {})

export function ToastProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState('')
  const [on, setOn] = useState(false)
  const timer = useRef<number>()

  const toast = useCallback((text: string) => {
    setMessage(text)
    setOn(true)
    window.clearTimeout(timer.current)
    timer.current = window.setTimeout(() => setOn(false), 2500)
  }, [])

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className={`toast${on ? ' show' : ''}`}>{message}</div>
    </ToastContext.Provider>
  )
}

export const useToast = (): ((message: string) => void) => useContext(ToastContext)
